$(document).ready(function() {
  var paddleConfig = $("#paddle-config");
  if(paddleConfig.length > 0) {
    if(typeof window.Paddle == 'object') {
      Paddle.Setup(paddleConfig.data("config"));
    }
  }
});
